var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { useEffect } from "react";
import { redirect, useLoaderData, useLocation, useNavigate, useParams } from "react-router-dom";
import { LEGACY_ROUTES, Routes } from "../Shared/components/Navigation/navigationUtils";
import { LocationPageWrapper } from "../Shared/components/PageWrapper/LocationPageWrapper";
import Loading from "../Shared/components/loading";
import { useLogging } from "../Shared/hooks/useLogging/useLogging";
import { axiosPrivate } from "../api/axios";
import { DeliverySection } from "./DeliverySection";
import { LocationContentArea } from "./LocationContentArea";
import { LocationSkeleton } from "./LocationSkeleton";
import { LocationTitle } from "./LocationTitle";
import { PickupSection } from "./PickupSection";
import { useLocations } from "./useLocations";
export const Location = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { sku } = useParams();
    const { skipLocationPage, defaultLocation, defaultPostalCode } = useLoaderData();
    const { loading: locationFetchLoading, error: locationFetchError, deliveryMethodMarkdown, pickupIcon, pickupIconColor, pickUpMarkdown, pickUpSubtext, deliveryIcon, deliveryIconColor, deliveryMarkdown, deliverySubtext, contentArea, locations, shouldDisplayLocationSection, shouldDisplayDeliverySection, programId, } = useLocations(skipLocationPage);
    const { logReactPixelPageView, createKlaviyoEvent, gaPageView } = useLogging();
    useEffect(() => {
        if (!skipLocationPage) {
            logReactPixelPageView();
            gaPageView("Location", location.pathname);
            createKlaviyoEvent("PageView", {
                SelectedLocation: "Location",
            });
        }
    }, []);
    useEffect(() => {
        if (skipLocationPage) {
            if (defaultPostalCode) {
                navigate(`/${sku}/${Routes.ORDER_FLOW}`, {
                    replace: true,
                    state: Object.assign(Object.assign({}, location.state), { postalCode: defaultPostalCode }),
                });
            }
            if (defaultLocation) {
                navigate(`/${sku}/${Routes.ORDER_FLOW}`, {
                    replace: true,
                    state: Object.assign(Object.assign({}, location.state), { location: defaultLocation }),
                });
            }
        }
    }, [skipLocationPage, defaultPostalCode, defaultLocation, sku, location]);
    if (locationFetchError) {
        return _jsx(Loading, { error: true, text: locationFetchError });
    }
    if (locationFetchLoading) {
        return _jsx(LocationSkeleton, {});
    }
    return (_jsx(LocationPageWrapper, Object.assign({ id: "location-page-wrapper" }, { children: _jsxs(Stack, Object.assign({ spacing: 3 }, { children: [deliveryMethodMarkdown && _jsx(LocationTitle, Object.assign({}, { deliveryMethodMarkdown })), shouldDisplayDeliverySection && (_jsx(DeliverySection, { deliveryMarkdown: deliveryMarkdown, deliverySubtext: deliverySubtext, deliveryIcon: deliveryIcon, deliveryIconColor: deliveryIconColor, programId: programId })), shouldDisplayLocationSection && (_jsx(PickupSection, { pickUpMarkdown: pickUpMarkdown, pickUpSubtext: pickUpSubtext, locations: locations, pickupIcon: pickupIcon, pickupIconColor: pickupIconColor })), contentArea && _jsx(LocationContentArea, Object.assign({}, { contentArea }))] })) })));
};
export const LocationLoader = (request, params) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = new URL(request.url);
        // Redirect to new login if old route is hit
        if (url.pathname === LEGACY_ROUTES.LOGIN_REGISTER) {
            return redirect("/");
        }
        const [skuValidation, locationData] = yield Promise.all([
            axiosPrivate.get(`/Location/ValidateFlowSku?sku=${params.sku}`),
            axiosPrivate.get(`/Location/GetLocationSkipInfo?sku=${params.sku}`),
        ]);
        if (!skuValidation.data.isValidFlowSku) {
            return redirect(Routes.NOT_FOUND);
        }
        return Object.assign({}, locationData.data);
    }
    catch (e) {
        console.error(e);
        throw e;
    }
});
